export const errorV2Mappings = {
  'ORDER.SCHEDULER.RECURRENCE.UNTIL_LESS_THAN_DTSTART':
    'Gagal Disimpan. Tanggal Berakhir harus lebih besar dari Tanggal Mulai',
  'ORDER.SCHEDULER.RECURRENCE.UNTIL_DTSTART_THAN_NOW':
    'Gagal Disimpan. Tanggal Mulai harus lebih besar dari Tanggal Hari Ini',
}
